<web-widget-breadcrumbs [widget]="widget()" [isInSpecificSection]="isSpecific()" />

<div class="panel-options-body overflow-wrapper">
    <form class="form form-horizontal" (submit)="$event.preventDefault()">
        <div class="form-row mb-20">
            <div class="form-group">
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [min]="SIZE_MIN"
                        [max]="SIZE_MAX"
                        [value]="form.borderTopWidth().value()"
                        (valueChange)="form.setBorderTopWidth($event)"
                    />
                </div>
                <div class="col-xs-6">
                    <select class="form-control" (change)="form.setBorderTopStyle($any($event.target).value)">
                        <option
                            [value]="ELineStyle.SOLID"
                            [selected]="form.borderTopStyle().value() === ELineStyle.SOLID"
                        >
                            {{ "control_solid" | translate }}
                        </option>
                        <option
                            [value]="ELineStyle.DASHED"
                            [selected]="form.borderTopStyle().value() === ELineStyle.DASHED"
                        >
                            {{ "control_dashed" | translate }}
                        </option>
                        <option
                            [value]="ELineStyle.DOTTED"
                            [selected]="form.borderTopStyle().value() === ELineStyle.DOTTED"
                        >
                            {{ "control_dotted" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-2">
                    <web-color-picker-v2
                        [color]="form.borderTopColor().value()"
                        (colorChangeEvent)="setBorderTopColor($event)"
                        [hideGradient]="true"
                    />
                </div>
            </div>
        </div>

        <div class="form-group mb-20">
            <label class="col-xs-7 control-label">
                {{ "control_width" | translate }}
            </label>
            <div class="col-xs-5">
                <sp-input-num
                    suffixText="%"
                    [min]="SIZE_MIN"
                    [max]="SIZE_MAX"
                    [value]="form.width().value()"
                    (valueChange)="form.setWidth($event)"
                />
            </div>
        </div>

        <div class="form-row">
            <div class="form-group">
                <label class="control-label col-xs-7">
                    {{ "control_content_alignment" | translate }}
                </label>
                <div class="col-xs-5">
                    <sp-radio-group
                        [selected]="form.horizontalAlign().value()"
                        [type]="ERadioGroupType.horizontalPosition"
                        (changeSelectedEvent)="setHorizontalAlign($event)"
                    />
                </div>
            </div>
        </div>

        <div class="mt-20">
            <web-custom-id [displayId]="form?.displayId()" (valueChangeEvent)="form?.setDisplayId($event)" />
        </div>
    </form>
</div>
